export default __webpack_public_path__ + "images/0b2f1d39d8a2457fdcfd24fc9ca28af8.png";